export interface HotelRiskAmountThresholds {
   highMin: number; // >= highMin => High
   mediumMin: number; // >= mediumMin => Medium
   lowMax: number; // <= lowMax => Low (informational)
}

export const DEFAULT_HOTEL_RISK_AMOUNT_THRESHOLDS: HotelRiskAmountThresholds = {
   highMin: 500,
   mediumMin: 151,
   lowMax: 150
};
